import { api } from './apiService';
import axios from "axios";

// const BASE_URL = "http://localhost:5000";
// const BASE_URL = "http://localhost:8001";

export async function getUserDetails(code) {
  const response = await api.get(`/teams/decode/${code}`);
  console.log('team details:', response);
  return response.data;
}

export async function requestToken(code) {
  const response = await api.get(`/teams/request-token/${code}`);
  console.log('team details:', response);
  return response.data;
}
